import { IMetrics } from "../../interfaces";

export const limitMetricsTo100 = (metrics: IMetrics): IMetrics => {
  const updatedMetrics = Object.fromEntries(
    Object.entries(metrics).map(([key, value]) => [key, value > 100 ? (value = 100) : value]),
  );

  return updatedMetrics as IMetrics;
};
